var _path, _circle, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckCredly(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 42c11.598 0 21-9.402 21-21S32.598 0 21 0H0v21.573h.008C.31 32.906 9.594 42 21 42z",
    fill: "#0FFE00"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 17.945,
    fill: "#1F363D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 35c7.71 0 14-6.234 14-14 0-7.71-6.29-14-14-14-7.766 0-14 6.29-14 14 0 7.766 6.234 14 14 14zm6.18-16.57l-7 7c-.547.547-1.367.547-1.86 0l-3.5-3.5a1.198 1.198 0 010-1.805c.492-.547 1.313-.547 1.86 0l2.57 2.57 6.07-6.125a1.287 1.287 0 011.805 0c.547.547.547 1.367 0 1.86h.055z",
    fill: "#0FFE00"
  })));
}
export default SvgCheckCredly;